import routes from 'domain/routes';
import React from 'react';
import ArticleFormContainer from '../Form';

const CreateArticle = () => {
    return (
        <ArticleFormContainer
            moduleTitle='Create article'
            moduleTitleActions={[
                {
                    name: 'Back to list',
                    url: routes.panel.blog.main,
                },
            ]}
        />
    );
};

export default CreateArticle;
